/**
 * Module-level overlay store for the sticker creator.
 *
 * Mounted ONCE at the app shell level so the creator UI survives:
 *  - chat route remounts
 *  - search-param navigations
 *  - mobile keyboard / native file picker round-trips
 *
 * The chat-route subtree only DISPATCHES open/close. It does not own
 * the lifecycle of the creator anymore.
 */

export interface StickerCreateOverlayState {
  open: boolean;
  conversationId: string | null;
  refreshNonce: number;
  source: string | null;
}

const INITIAL: StickerCreateOverlayState = {
  open: false,
  conversationId: null,
  refreshNonce: 0,
  source: null,
};

let state: StickerCreateOverlayState = { ...INITIAL };
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => {
    try { l(); } catch { /* ignore */ }
  });
}

export function getStickerCreateOverlay(): StickerCreateOverlayState {
  return state;
}

export function subscribeStickerCreateOverlay(fn: () => void): () => void {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

export function openStickerCreate(conversationId: string | null, source: string = "chat") {
  console.log("[StickerOverlay] open", { conversationId, source });
  state = { ...state, open: true, conversationId, source };
  emit();
}

export function closeStickerCreate() {
  console.log("[StickerOverlay] close");
  state = { ...state, open: false, source: null };
  emit();
}

export function bumpStickerRefresh() {
  state = { ...state, refreshNonce: state.refreshNonce + 1 };
  console.log("[StickerOverlay] bump refresh", state.refreshNonce);
  emit();
}
